module.exports = __webpack_public_path__ + "static/Birds_01_mobile-e28c1ed9a21a7608c2a91aa3344fde59.webp";